import BaseService from '../base';

class Placement extends BaseService {}

export default new Placement('placements', 'Placement');
